import React from 'react';
import classnames from 'classnames';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { Text } from '../text';
import styles from './tooltip.module.scss';

export type TooltipProps = {
  id: string;
  text: string | React.ReactNode;
  label?: string;
  className?: string;
};

export const Tooltip: React.FC<TooltipProps> = ({ label, text, id, className }): JSX.Element => {
  const classes = classnames(styles.tooltip, className);

  return (
    <>
      <ReactTooltip anchorSelect={`#${id}`} opacity="1" className={classes}>
        {label && <div className={styles.label}>{label}</div>}
        {typeof text === 'string' ? (
          <Text variant="paragraph-100" className={styles.text}>
            {text}
          </Text>
        ) : (
          <div className={styles.text}>{text}</div>
        )}
      </ReactTooltip>
    </>
  );
};
